import { WEI, } from "@bracket/blocksmith";
import type { AssetUSD, BrktUSD, } from "@bracket/types";
import type { DepWithBrktUSD, } from "./types";


export const defaultBrktUSD: () => BrktUSD = () => Object.assign({}, { brkt: "-1", usd: -1, });


export const defaultAssetUSD: () => AssetUSD = () => Object.assign({}, { asset: WEI.fromSync(-1), usd: -1, });


export const defaultDepWithBrktUSD: () => DepWithBrktUSD = () => Object.assign({}, {
	deposits: defaultBrktUSD(),
	withdrawals: defaultBrktUSD(),
});
